<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family03.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 1200,
						end: 1600,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(0)' },
           				toStyle: { transform: 'translateX(0%) translateY(0%) scale(1)' },
						easing: 'linear'
					},
					{
						start: 3600,
						end: 4000,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(1)' },
           				toStyle: { transform: 'translateX(-60%) translateY(-40%) scale(1)' },
						easing: 'linear'
					},
					{
						start: 4000,
						end: 5000,
						fromStyle: { transform: 'translateX(-60%) translateY(-40%) scale(1)' },
           				toStyle: { transform: 'translateX(-1000%) translateY(-40%) scale(1)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 170px;
	    position: absolute;
	    left: 5%;
	    top: 18%;
	    z-index: 2;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-polaroid {
			max-width: 150px;
			left: 6%;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-polaroid {
			max-width: 80px;
			left: 6%;
		}
	}

	@media screen and (max-width: 650px) {
		.slide-polaroid {max-width: 45px;}
	}
</style>
